import {
  ReactNode,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import ResizeObserver from 'lib/resize-observer';
import * as Styled from './activity-builder-component-preview.style';

const ActivityBuilderComponentPreview = ({
  children,
  container,
  content,
}: {
  children: ReactNode;
  container?: {
    width: number;
  };
  content: {
    width: number;
    height: number;
  };
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const [containerWidth, setcontainerWidth] = useState<number>(
    container?.width || 0
  );
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { scaleX, paddingTop } = useMemo(() => {
    return {
      scaleX: containerWidth / content.width,
      paddingTop: (content.height / content.width) * 100,
    };
  }, [content, containerWidth]);

  const updateContainerWidth = useCallback(() => {
    if (containerRef.current?.offsetWidth) {
      setcontainerWidth(containerRef.current.offsetWidth);
    }
  }, []);

  useEffect(() => {
    const refCopy = containerRef.current;
    const resizeObserver = new ResizeObserver(updateContainerWidth);

    if (refCopy) {
      resizeObserver.observe(refCopy);
    }

    return () => {
      if (refCopy) {
        resizeObserver.unobserve(refCopy);
      }
    };
  }, [updateContainerWidth]);

  useEffect(() => {
    setTimeout(() => setIsLoading(false), 200);
  }, []);

  return (
    <Styled.ComponentPreviewWrapper
      ref={el => {
        containerRef.current = el;
        if (el?.offsetWidth) {
          setcontainerWidth(el.offsetWidth);
        }
      }}
      $isLoading={isLoading}
      style={{
        paddingTop: `${paddingTop}%`,
      }}
    >
      <Styled.ComponentPreview
        style={{
          transform: `scale(${scaleX})`,
          width: `${content.width}px`,
          height: `${content.height}px`,
        }}
      >
        {children}
      </Styled.ComponentPreview>
    </Styled.ComponentPreviewWrapper>
  );
};

export default ActivityBuilderComponentPreview;
